import * as types from './meeting-archive.types';
import * as constants from './meeting-archive.constants';
import { Reducer, combineReducers } from 'redux';
import { isActionOfType } from '../../../../utils/action.utils';

const initialState: types.IMeetingArchivesPageState = {
  meetingArchivesIds: [],
  currentPage: null,
  totalPages: null,
};

const meetingsArchivesIdsReducer: Reducer<
  types.IMeetingArchivesPageState['meetingArchivesIds'],
  types.IStoreMeetingArchivesIds | types.IClearMeetingArchivesIds
> = (state = initialState.meetingArchivesIds, action) => {
  if (isActionOfType<types.IStoreMeetingArchivesIds>(action, constants.STORE_MEETING_ARCHIVE_IDS)) {
    return action.payload;
  } else if (isActionOfType<types.IClearMeetingArchivesIds>(action, constants.CLEAR_MEETING_ARCHIVE_IDS)) {
    return initialState.meetingArchivesIds;
  }

  return state;
};

const currentPageReducer: Reducer<
  types.IMeetingArchivesPageState['currentPage'],
  types.IStoreMeetingArchiveCurrentPage | types.IClearMeetingArchiveCurrentPage
> = (state = initialState.currentPage, action) => {
  if (isActionOfType<types.IStoreMeetingArchiveCurrentPage>(action, constants.STORE_MEETING_ARCHIVE_CURRENT_PAGE)) {
    return action.payload;
  } else if (
    isActionOfType<types.IClearMeetingArchiveCurrentPage>(action, constants.CLEAR_MEETING_ARCHIVE_CURRENT_PAGE)
  ) {
    return initialState.currentPage;
  }

  return state;
};

const totalPagesPageReducer: Reducer<
  types.IMeetingArchivesPageState['totalPages'],
  types.IStoreMeetingArchiveTotalPages | types.IClearMeetingArchiveTotalPages
> = (state = initialState.totalPages, action) => {
  if (isActionOfType<types.IStoreMeetingArchiveTotalPages>(action, constants.STORE_MEETING_ARCHIVE_TOTAL_PAGES)) {
    return action.payload;
  } else if (
    isActionOfType<types.IClearMeetingArchiveTotalPages>(action, constants.CLEAR_MEETING_ARCHIVE_TOTAL_PAGES)
  ) {
    return initialState.totalPages;
  }

  return state;
};

export const meetingArchivesPageReducer: Reducer<
  types.IMeetingArchivesPageState,
  types.IMeetingArchivesPageAction
> = combineReducers({
  meetingArchivesIds: meetingsArchivesIdsReducer,
  currentPage: currentPageReducer,
  totalPages: totalPagesPageReducer,
});
